import React from 'react';

import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useSnackbar } from 'notistack';

import functionalitiesService, { funcionalidades } from 'src/services/functionalitiesService';


function AuthGuard({ children }) {
  const { enqueueSnackbar } = useSnackbar();
  const account = useSelector((state) => state.account);

  // Rutas que solo estan disponibles en la app movil
 const routeOnlyMobile = [
    // '/app/completar/registro', 
    '/app/seguridad'
  ];
    // Rutas que solo estan disponibles para usuarios que completaron el registro
  const routeOnlyCompleteRegister = [
    '/app/transferencias'
  ]

  // Rutas para igualar por codigos de funcionalidad para determinar si dicha accion/funcionalidad esta activa
  const routeEqualCodeFunctionality = [
    {
      code: funcionalidades.TRANSFER.key,
      route: '/app/transferencias'
    },

  ]


  // Ruta actual
  const route = window.location.pathname;

  // Funcion que determina si la aplicacion esta corriendo en un dispositivo movil
  // si encuentra la variable window.ReactNativeWebView es porque esta corriendo en un dispositivo movil
  const isMobile = () => {
    // console.log('isMobile -->',(window.ReactNativeWebView ? true : false))
    return (window.ReactNativeWebView ? true : false);
  }

  // Funcion que determina si la ruta actual es solo para movil
  // si la ruta actual se encuentra en el arreglo routeOnlyMobile, es porque es solo para movil
  const isRouteOnlyMobile = () => {
      // console.log('isRouteOnlyMobile -->',routeOnlyMobile.includes(route))
    return routeOnlyMobile.includes(route);
  }

    // Funcion que determina si la ruta actual es solo para usuarios los cuales completaron el registro
  // si la ruta actual se encuentra en el arreglo routeOnlyCompleteRegister, es porque es solo para usuarios los cuales completaron el registro
  const isRouteOnlyCompleteRegister = () => {
    return routeOnlyCompleteRegister.includes(route);
  }

  // Funcion que determina si la ruta actual es igual a la ruta de la funcionalidad
  // si la ruta actual se encuentra en el arreglo routeEqualCodeFunctionality, es porque es igual a la ruta de la funcionalidad
  const isRouteEqualCodeFunctionality = () => {
    return routeEqualCodeFunctionality.some((item) => {
      if(item.route === route) {
        functionalitiesService.funcionalidadHabilitada({codigo: item.code, documento: account.user.username})
        .then((response) => {
          if (response === true) {
            return true;
          } else {
            enqueueSnackbar('Esta funcionalidad no está habilitada.', {
              variant: 'info'
            });
            return false;
          }
        })
        .catch(() => {
          enqueueSnackbar('Esta funcionalidad no está habilitada.', {
            variant: 'info'
          });
          return false;
        })
      }
    });
  }




  // Si el usuario no esta logueado, se redirecciona a la pagina de login
  if (!account.user) {
    return <Redirect to="/login" />;
  }

  // Si la ruta actual es solo para movil y no se encuentra en un dispositivo movil
  if(isRouteOnlyMobile() && !isMobile()){
    enqueueSnackbar('Por su seguridad, esta sección solo está disponible en la app.', {
      variant: 'info'
    });
    return <Redirect to="/app" />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
